import React from 'react';
import cssClasses from './SalesDashboard.module.css';
import RuppesIcon from '../../Assets/Images/Common/RuppesIcon.svg';
import {
  Box,
  Card,
  Divider,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
} from '@mui/material';
import DateComponent from '../../Subcomponents/DateComponent';
import { Bar, Doughnut } from 'react-chartjs-2';
import { useState } from 'react';
import { dismissLoader, presentLoader } from '../../Services/loader';
import { useSelector } from 'react-redux';
import { errorTost } from '../../Services/Toast';
import {
  FetchInventoryFromServer,
  getAllEvents,
  getAllotmentByUser,
  getCancelledRevenue,
  getEventAssignedToUser,
  getEventTokenByIds,
  getLeadConversionByIds,
  getPaymentStatusByIds,
  getSelectedProjectByIds,
  getSelectedProjectsForDashboard,
  getSiteVisits,
  individualSiteVisits,
} from '../../Services/Dashboard';
import { useEffect } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import _, { groupBy } from 'lodash';
import actions from '../../Redux Store/actions';
import { useDispatch } from 'react-redux';
import CustomAutoComplete from '../../Subcomponents/CustomAutoComplete';
import { useNavigate } from 'react-router';
import MultiSelectDropDown from '../../Subcomponents/MultiSelectDropDown/MultiSelectDropDown';
import { getAllProjects } from '../../Services/AssignProject';
import LeadStatusChip from '../../Subcomponents/LeadStatusChip';
import Dot from '../Icons/Dot';
import { getLaunchWise } from '../../Services/Event';
import { supabase } from '../../supabaseClient';
// import EmptyState from '../../Assets/Images/Common/noProjectFound.svg';

const dataGridStyles = {
  '&.MuiDataGrid-root .MuiDataGrid-cell:focus': {
    outline: 'none',
  },
  border: '1px solid #EAECF0 !important',
  fontWeight: '400',
  fontSize: '1.4rem',
  lineHeight: '2rem',
  color: '#667085',
  fontFamily: 'Inter-Medium',
  borderRadius: '8px',
  '& div[data-colindex="1"]': {
    color: '#101828',
    fontWeight: '500',
  },
  '& .MuiDataGrid-virtualScrollerRenderZone': {
    '& .MuiDataGrid-row': {
      borderBottom: '1px solid #EAECF0',
      background: '#FFFFFF',
      borderRadius: '1rem',
    },
    '& .MuiDataGrid-row.Mui-selected:hover': {
      borderBottom: '1px solid #EAECF0',
      backgroundColor: '#FFFFFF',
    },
  },
  '& .MuiDataGrid-iconSeparator ': {
    display: 'none',
  },
  '& .MuiDataGrid-columnHeader:hover': {
    '& .MuiDataGrid-menuIcon': {
      visibility: 'hidden',
    },
  },
  '& .MuiDataGrid-columnHeaders + div': {
    height: 'calc(100vh - 290px) !important',
  },
  '&  .MuiDataGrid-columnHeaders': {
    background: '#F9FAFB',
    border: '1px solid #EAECF0',

    marginBottom: '1rem',
    borderBottom: '6px solid #EAECF0',
  },
  '& .MuiDataGrid-columnSeparator': {
    display: 'none',
  },
  '& .MuiDataGrid-checkboxInput': {
    '& svg': {
      width: '2rem',
      height: '2rem',
      background: '#FFFFFF',
    },
  },
  '& .MuiDataGrid-footerContainer': {
    '& .MuiTablePagination-displayedRows ': {
      display: 'none',
    },
    '& .MuiDataGrid-selectedRowCount': {
      visibility: 'hidden ',
    },
  },
  "&  [title='Sort']": {
    display: 'none',
    cursor: 'none',
  },
  "& [title='Go to previous page']": {
    borderRadius: '0',
    border: '1px solid #EAECF0',
    borderRadius: '0.8rem',
    marginRight: '0.5rem',
  },
  "& [title='Go to next page']": {
    borderRadius: '0',
    border: '1px solid #EAECF0',
    borderRadius: '0.8rem',
    marginRight: '0.5rem',
  },
  "& [title='Go to previous page']:after": {
    content: "'Previous'",
    marginLeft: '1rem',
  },
  "& [title='Go to next page']:before": {
    content: "'Next'",
    marginRight: '1rem',
  },
  '& .MuiDataGrid-columnHeader': {
    padding: '0 4rem',

    '&:focus': {
      outline: 'none',
    },
  },
  '&  .MuiDataGrid-row ': {
    maxHeight: '72px !important',
    minHeight: '72px !important',
  },
  '& .MuiDataGrid-cell': {
    padding: '0 4rem',
    minHeight: '72px !important',
    maxHeight: '72px !important',
    '&:focus': {
      outline: 'none',
    },
  },
  '& .MuiButtonBase-root': {
    fontSize: '1.6rem',
  },
  '& .MuiDataGrid-cell:focus-within': {
    outline: 'none !important',
  },
  '& .MuiDataGrid-cell': {
    padding: '0 2rem',
    minHeight: '72px !important',
    maxHeight: '72px !important',
    '&:focus': {
      outline: 'none',
    },
  },
  '& .MuiDataGrid-columnHeader': {
    padding: '0 1rem',

    '&:focus': {
      outline: 'none',
    },
  },
};

const SalesDashboard = () => {
  const loggedInUser = useSelector((state) => state.Auth.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [purchasedRevenue, setPurchasedRevenue] = useState(0);
  const [cancelledRevenue, setCancelledRevenue] = useState(0);
  const userIds = JSON.parse(localStorage.getItem('teamIds'));
  const [mode, setMode] = useState('Allotment');
  const [allAllotmentData, setAllAllotmentData] = useState([]);
  const [individualAllotment, setIndividualAllotment] = useState([]);
  const [inventory, setInventory] = useState([]);
  const [projectList, setProjectList] = useState([]);
  const [projectDataList, setProjectDataList] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [selectedLaunch, setSelectedLaunch] = useState(null);
  const [eventOption, setEventOption] = useState([]);
  const [launchOption, setLaunchOption] = useState([]);
  const [preselectToken, setPreselectToken] = useState([]);
  const [priorityPassToken, setPriorityPassToken] = useState([]);
  const [globalToken, setGlobalToken] = useState([]);
  const [noTVBFound, setNoTVBFound] = useState(false);
  const [tokenCount, setTokenCount] = useState([]);
  const [paymentStatusData, setPaymentStatusData] = useState([]);
  const [leadConversionData, setLeadConversionData] = useState([]);
  const [selectedProject, setSelectedProject] = useState([]);
  const [allSelected, setAllSelected] = useState([])
  const [siteVisit, setSiteVisit] = useState([])
  const [individualSiteVisit, setIndividualSiteVisit] = useState([])
  const individualFlag =
    loggedInUser?.isTeamLead && loggedInUser?.isTeamLead === true
      ? false
      : true;

  const [helperText, setHelperText] = useState({
    startDate: '',
    endDate: '',
  });
  const [selectDates, setSelectDates] = useState([
    {
      label: 'StartDate',
      value: '',
      // value: window?.location?.search?.split?.('?')?.[2]
      //   ? window?.location?.search?.split?.('?')[2].split('=')[1] !== '0'
      //     ? window?.location?.search?.split?.('?')[2].split('=')[1]
      //     : ''
      //   : '',
    },
    {
      label: 'EndDate',
      value: '',
      // value: window?.location?.search?.split?.('?')?.[3]
      //   ? window?.location?.search?.split?.('?')[3].split('=')[1] !== '0'
      //     ? window?.location?.search?.split?.('?')[3].split('=')[1]
      //     : ''
      //   : '',
    },
  ]);
  

  const tagGridColumns = [
    {
      field: 'Projects',
      headerName: 'Projects',
      width: 270,
      renderCell: (params) => {
        return <div>{params?.row?.val[0]?.unitId?.projectId?.projectName}</div>;
      },
    },
    {
      field: 'Sold',
      headerName: 'Sold',
      width: 130,
      renderCell: (params) => {
        return <div>{params?.row?.sold}</div>;
      },
    },
    {
      field: 'Area',
      headerName: 'Area',
      width: 130,
      renderCell: (params) => {
        return <div>{params?.row?.area} sq.ft</div>;
      },
    },
    {
      field: 'Value',
      headerName: 'Value',
      width: 100,
      renderCell: (params) => {
        return <div>₹ {numDifferentiation(params?.row?.cost)}</div>;
      },
    },
    {
      field: 'Actions',
      headerName: '',
      width: 140,
      renderCell: (params) => {
        return (
          <div
            style={{
              textDecoration: 'underline',
              color: 'rgba(112, 123, 154, 1)',
              cursor: 'pointer',
            }}
            onClick={() =>
              navigate(
                `/home/Dashboard/Allotment?projectName=${
                  params?.row?.val[0]?.unitId?.projectId?.projectName
                }?startDate=${
                  selectDates[0]?.value !== '' ? selectDates[0]?.value : 0
                }?endDate=${
                  selectDates[1]?.value !== '' ? selectDates[1]?.value : 0
                }?salesPerson=All`
              )
            }
          >
            View Details
          </div>
        );
      },
    },
  ];
  const tagGridColumns2 = [
    {
      field: 'Projects',
      headerName: 'Projects',
      width: 350,
      renderCell: (params) => {
        return <div>{params?.row[0]?.projectId?.projectName}</div> 
      },
    },
    {
      field: 'Site Visits',
      headerName: 'Site Visits',
      width: 130,
      renderCell: (params) => {
        return <div>{params?.row?.length}</div>;
      },
    },

  ];

  const IndividualGridColumns = [
    {
      field: 'Lead Name',
      headerName: 'Lead Name',
      width: 270,
      renderCell: (params) => {
        return <div>{params?.row?.leadId?.personId?.name}</div>;
      },
    },
    {
      field: 'Status',
      headerName: 'Status',
      width: 230,
      renderCell: (params) => {
        return (
          <div style={{ wordBreak: 'break-word' }}>
            <div className={cssClasses.tokenStatus}>
              {params?.row?.status === 'On Hold' && (
                <LeadStatusChip
                  label={params?.row?.status}
                  icon={<Dot width={'0.5rem'} height={'0.5rem'} />}
                  style={{
                    color: 'rgb(89, 37, 220)',
                    backgroundColor: 'rgb(244, 243, 255)',
                  }}
                ></LeadStatusChip>
              )}
              {params?.row?.status === 'Agreement Done' && (
                <LeadStatusChip
                  label={params?.row?.status}
                  icon={<Dot width={'0.5rem'} height={'0.5rem'} />}
                  style={{
                    color: '#1570EF',
                    backgroundColor: '#EFF8FF',
                  }}
                ></LeadStatusChip>
              )}
              {(params?.row?.status === 'Released' ||
                params?.row?.status.includes('Refund')) && (
                <LeadStatusChip
                  label={params?.row?.status}
                  icon={<Dot width={'0.5rem'} height={'0.5rem'} />}
                  style={{
                    color: 'rgb(180, 35, 24)',
                    backgroundColor: 'rgb(254, 243, 242)',
                  }}
                ></LeadStatusChip>
              )}
              {params?.row?.status.toLowerCase().includes('cancel') && (
                <LeadStatusChip
                  label={params?.row?.status}
                  icon={<Dot width={'0.5rem'} height={'0.5rem'} />}
                  style={{
                    color: 'rgb(180, 35, 24)',
                    backgroundColor: 'rgb(254, 243, 242)',
                  }}
                ></LeadStatusChip>
              )}
              {params?.row?.status === 'Partial Payment Done' && (
                <LeadStatusChip
                  label={params?.row?.status}
                  icon={<Dot width={'0.5rem'} height={'0.5rem'} />}
                  style={{ color: '#B54708', backgroundColor: '#FFFAEB' }}
                ></LeadStatusChip>
              )}
              {params?.row?.status === 'Payment Complete' && (
                <LeadStatusChip
                  label={params?.row?.status}
                  icon={<Dot width={'0.5rem'} height={'0.5rem'} />}
                  style={{ color: '#027A48', backgroundColor: '#ECFDF3' }}
                ></LeadStatusChip>
              )}
              {params?.row?.status === 'Preselected' && (
                <LeadStatusChip
                  label={params?.row?.status}
                  icon={<Dot width={'0.5rem'} height={'0.5rem'} />}
                  style={{ color: '#027A48', backgroundColor: '#ECFDF3' }}
                ></LeadStatusChip>
              )}
              {params?.row?.status === 'Payment Pending' && (
                <LeadStatusChip
                  label={params?.row?.status}
                  icon={<Dot width={'0.5rem'} height={'0.5rem'} />}
                  style={{ color: '#B42318', backgroundColor: '#FEF3F2' }}
                ></LeadStatusChip>
              )}
              {params?.row?.status === 'Change Requested' && (
                <LeadStatusChip
                  label={params?.row?.status}
                  icon={<Dot width={'0.5rem'} height={'0.5rem'} />}
                  style={{ color: '#B42318', backgroundColor: '#FEF3F2' }}
                ></LeadStatusChip>
              )}
            </div>
          </div>
        );
      },
    },
    {
      field: 'Project Name',
      headerName: 'Project Name',
      width: 250,
      renderCell: (params) => {
        return <div>{params?.row?.unitId?.projectId?.projectName}</div>;
      },
    },
  ];

  const tagGridColumns1 = [
    {
      field: 'Projects',
      headerName: 'Projects',
      width: 270,
      renderCell: (params) => {
        return <div>{params?.row?.val[0]?.wingId?.projectId?.projectName}</div>;
      },
    },
    {
      field: 'Sold Inventory',
      headerName: 'Sold Inventory',
      width: 170,
      renderCell: (params) => {
        return (
          <div
            style={{
              color: 'rgba(112, 123, 154, 1)',
              fontFamily: 'inter-semibold',
            }}
          >
            {params?.row?.sold}
          </div>
        );
      },
    },
    {
      field: 'Unsold Inventory',
      headerName: 'Unsold Inventory',
      width: 170,
      renderCell: (params) => {
        return (
          <div
            style={{
              color: 'rgba(112, 123, 154, 1)',
              fontFamily: 'inter-semibold',
            }}
          >
            {params?.row?.unsold}
          </div>
        );
      },
    },
    {
      field: 'Total',
      headerName: 'Total',
      width: 80,
      renderCell: (params) => {
        return (
          <div
            style={{
              color: 'rgba(112, 123, 154, 1)',
              fontFamily: 'inter-semibold',
            }}
          >
            {params?.row?.totalUnit}
          </div>
        );
      },
    },
    {
      field: 'Actions',
      headerName: '',
      width: 140,
      renderCell: (params) => {
        return (
          <div
            style={{
              textDecoration: 'underline',
              color: 'rgba(112, 123, 154, 1)',
              cursor: 'pointer',
            }}
            onClick={() =>
              navigate(
                `/home/Dashboard/Inventory?projectName=${
                  params?.row?.val[0]?.wingId?.projectId?.projectName
                }?startDate=${
                  selectDates[0]?.value !== '' ? selectDates[0]?.value : 0
                }?endDate=${
                  selectDates[1]?.value !== '' ? selectDates[1]?.value : 0
                }`
              )
            }
          >
            View Details
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    dispatch(actions.activeMenu('dashboard'));
    siteVisits();
    const fetchProjects = async () => {
      const selectedProjectList = await getSelectedProjectsForDashboard(
        loggedInUser?.isTeamLead && loggedInUser?.isTeamLead === true
          ? userIds
          : [loggedInUser?.userId]
      );
      const uniqProject = groupBy(
        selectedProjectList?.data,
        (v) => v?.unitId?.projectId
      );
      const uniqSelectedProjectId = Object.keys(uniqProject)?.map((v) => {
        return v;
      });
      const arr = [];
      const urlProject = [];
      if (uniqSelectedProjectId?.length > 0) {
        const projectArr = await getAllProjects();
        projectArr.data.forEach((v) => {
          const index = uniqSelectedProjectId?.findIndex(
            (i) => i === v?.projectId
          );
          if (index !== -1) {
            arr.push({
              name: v?.projectName,
              id: v?.projectId,
            });
          }
        });
        const url_arr1 = window?.location?.search
          ?.split?.('?')[1]
          ?.split('=')[1]
          ?.split(',')
          ?.forEach((em) => {
            const url_val = arr.find(
              (f) => f?.name.replaceAll(/\s/g, '') === em.replace(/[%20]/g, '')
            );
            if (url_val !== undefined) {
              urlProject.push(url_val);
              setSelectedProject((pre) => {
                return [...pre, url_val];
              });
            }
          });
        setProjectDataList(arr);
      } else {
        setProjectDataList([]);
      }
      return { arr, urlProject };
    };

    presentLoader();
    fetchProjects()
      .then(async (v) => {
        await getCancelledRevenueCount(
          (v?.urlProject?.length > 0 ? v?.urlProject : v?.arr)?.map((value) => {
            return value?.id;
          }),
          selectDates
        )
          .then(async () => {
            await getPaymentStatusData(
              (v?.urlProject?.length > 0 ? v?.urlProject : v?.arr)?.map(
                (value) => {
                  return value?.id;
                }
              ),
              selectDates
            )
              .then(async () => {
                await getInventoryCount(
                  (v?.urlProject?.length > 0 ? v?.urlProject : v?.arr)?.map(
                    (value) => {
                      return value?.id;
                    }
                  ),
                  selectDates
                )
                  .then(() => {
                    dismissLoader();
                  })
                  .catch((e) => {
                    dismissLoader();
                    errorTost(e.message);
                  });

                if (individualFlag) {
                  await getIndividualLeadConversion(
                    (v?.urlProject?.length > 0 ? v?.urlProject : v?.arr)?.map(
                      (value) => {
                        return value?.id;
                      }
                    ),
                    selectDates
                  )
                    .then(async () => {
                      await getIndividualAllotments(
                        (v?.urlProject?.length > 0
                          ? v?.urlProject
                          : v?.arr
                        )?.map((value) => {
                          return value?.id;
                        }),
                        selectDates
                      )
                        .then(() => {
                          dismissLoader();
                        })
                        .catch((e) => {
                          dismissLoader();
                          errorTost(e.message);
                        });
                      await getIndividualSiteVisits(loggedInUser?.userId)
                    })
                    .catch((e) => {
                      dismissLoader();
                      errorTost(e.message);
                    });
                }
              })
              .catch((e) => {
                dismissLoader();
                errorTost(e.message);
              });
          })
          .catch((e) => {
            dismissLoader();
            errorTost(e.message);
          });
      })
      .catch((e) => {
        dismissLoader();
        errorTost(e.message);
      });
  }, []);

  useEffect(() => {
    if (selectedEvent !== null) {
      getEventTokenData();
    }
  }, [selectedEvent]);

  useEffect(() => {
    if (
      selectDates[0]?.value !== null &&
      selectDates[1]?.value !== null &&
      selectedEvent !== null &&
      selectDates[0]?.value !== '' &&
      selectDates[1]?.value !== ''
    ) {
      getEventTokenData();
    }
  }, [selectDates]);

  const getFirstSelectedEventData = () => {
    presentLoader();
    getAllEvents()
      .then((resp) => {
        getEventAssignedToUser(
          loggedInUser?.isTeamLead && loggedInUser?.isTeamLead === true
            ? userIds
            : [loggedInUser?.userId]
        ).then((value) => {
          if (value.data.length === 0) {
            setNoTVBFound(true);
          } else {
            setNoTVBFound(false);
          }
          dismissLoader();
          const selectedEvents = resp?.data
            ?.map((v) => {
              const index = value?.data?.findIndex(
                (i) => i?.launchId?.eventId === v?.eventId
              );
              if (index !== -1) {
                return {
                  ...v,
                };
              }
            })
            .filter((v) => v !== undefined && v !== null);

          setEventOption(
            selectedEvents?.map((v) => {
              return { ...v, label: v?.title, id: v?.eventId };
            })
          );
          const live_event_payload = selectedEvents
            ?.filter(
              (v) =>
                new Date(v.startDateTime).getTime() <= new Date().getTime() &&
                new Date(v.endDateTime).getTime() >= new Date().getTime()
            )
            .sort((a, b) => b.startDateTime - a.startDateTime);

          const upcoming_event_payload = selectedEvents
            ?.filter(
              (v) => new Date(v.startDateTime).getTime() > new Date().getTime()
            )
            .sort((a, b) => b.startDateTime - a.startDateTime);

          const closed_event_payload = selectedEvents
            ?.filter(
              (v) => new Date(v.endDateTime).getTime() < new Date().getTime()
            )
            .sort((a, b) => b.startDateTime - a.startDateTime);

          const urlEvent = selectedEvents.filter(
            (e) =>
              e.title.replaceAll(/\s/g, '') ===
              window?.location?.search
                ?.split?.('?')[1]
                ?.split('=')[1]
                ?.replace(/[%20]/g, '')
          );

          navigate(
            `/home/Dashboard?eventName=${
              urlEvent?.length > 0
                ? urlEvent[0]?.title
                : live_event_payload?.length > 0
                ? live_event_payload[0]?.title
                : upcoming_event_payload?.length > 0
                ? upcoming_event_payload[0]?.title
                : closed_event_payload[0]?.title
            }?startDate=${
              selectDates[0]?.value !== '' ? selectDates[0]?.value : 0
            }?endDate=${
              selectDates[1]?.value !== '' ? selectDates[1]?.value : 0
            }`
          );

          setSelectedEvent(
            urlEvent?.length > 0
              ? {
                  ...urlEvent[0],
                  id: urlEvent[0]?.eventId,
                  label: urlEvent[0]?.title,
                }
              : live_event_payload?.length > 0
              ? {
                  ...live_event_payload[0],
                  id: live_event_payload[0]?.eventId,
                  label: live_event_payload[0]?.title,
                }
              : upcoming_event_payload?.length > 0
              ? {
                  ...upcoming_event_payload[0],
                  id: upcoming_event_payload[0]?.eventId,
                  label: upcoming_event_payload[0]?.title,
                }
              : {
                  ...closed_event_payload[0],
                  id: closed_event_payload[0]?.eventId,
                  label: closed_event_payload[0]?.title,
                }
          );
        });
      })
      .catch((err) => {
        dismissLoader();
        errorTost(err.message);
      })
      .catch((err) => {
        dismissLoader();
        errorTost(err.message);
      });
  };



  useEffect(() => {
    console.log({ loggedInUser });
    let updateInventoryListener = supabase
      .from(`Inventory`)
      .on("UPDATE", (handleRecordUpdated) => {
        console.log(handleRecordUpdated);
        if (handleRecordUpdated.eventType === "UPDATE") {
          getInventoryCount(selectedProject?.map((i) => {
            return i?.id;
          }), selectDates)
        }
      })
      .on("INSERT", (handleRecordUpdated) => {
        console.log(handleRecordUpdated);
        if (handleRecordUpdated.eventType === "UPDATE") {
          getInventoryCount(selectedProject?.map((i) => {
            return i?.id;
          }), selectDates)
        }
      })
      .subscribe((status) => {
        console.log("status: ", status);
      });
      let updateAllotmentListener = supabase
      .from(`AllotmentPayment`)
      .on("UPDATE", (handleRecordUpdated) => {
        console.log(handleRecordUpdated);
        if (handleRecordUpdated.eventType === "UPDATE") {
          getCancelledRevenueCount(selectedProject?.map((i) => {
            return i?.id;
          }), selectDates)
        }
      })
      .on("INSERT", (handleRecordUpdated) => {
        console.log(handleRecordUpdated);
        if (handleRecordUpdated.eventType === "UPDATE") {
          getCancelledRevenueCount(selectedProject?.map((i) => {
            return i?.id;
          }), selectDates)
        }
      })
      .subscribe((status) => {
        console.log("status: ", status);
      });
    return () => {
      if (updateInventoryListener) {
        supabase.removeSubscription(updateInventoryListener);
        updateInventoryListener = null;
      }
      if (updateAllotmentListener) {
        supabase.removeSubscription(updateAllotmentListener);
        updateAllotmentListener = null;
      }

    };
      
      
  }, [])

  useEffect(() => {
    if (selectedEvent !== null) {
      getEventTokenData();
      
    }
    if(selectedEvent?.eventId) {
      getLaunchTokenData();
    }

  }, [selectedEvent]);

  useEffect(() => {
    if (selectedLaunch !== null) {
      getEventTokenData();
      
    }

  }, [selectedLaunch]);

  useEffect(() => {
    if (
      selectDates[0]?.value !== null &&
      selectDates[1]?.value !== null &&
      selectedEvent !== null &&
      selectDates[0]?.value !== '' &&
      selectDates[1]?.value !== ''
    ) {
      getEventTokenData();
    }
  }, [selectDates]);

  const siteVisits = async() => {
    await getSiteVisits(loggedInUser?.isTeamLead && loggedInUser?.isTeamLead === true
      ? userIds
      : [loggedInUser?.userId]).then((resp) => {
        const data = _.groupBy(resp, (id) => id?.projectId?.projectId)
        const topSiteVisitProjects = Object.values(data)?.sort((a, b) => b.length - a.length).slice(0, 5)
      setSiteVisit(topSiteVisitProjects)
    }).catch((err) => {
      errorTost(err.message)
    })
  }
  const getLaunchTokenData = () => {
    presentLoader();
    getLaunchWise(selectedEvent?.eventId)
      .then((launchRes) => {
        const payload = launchRes?.map((v) => {
          return { ...v, label: v?.title, id: v?.launchId };
        });
        setLaunchOption(payload);
        dismissLoader();
      })
      .catch((err) => {
        errorTost(err.message);
        dismissLoader();
      });
  };

  const getEventTokenData = () => {
    presentLoader();
    getEventTokenByIds(
      loggedInUser?.isTeamLead && loggedInUser?.isTeamLead === true
        ? userIds
        : [loggedInUser?.userId],
      selectedEvent?.eventId,
      selectDates,
      selectedLaunch?.launchId
    )
      .then((resp) => {
        const filteredData = resp.data?.filter((el) => el.leadId !== null)
        const preselect_payload = _.groupBy(
          filteredData?.filter((v) => v?.eventTokenId?.tokenId?.isPreselect),
          (id) => id?.eventTokenId?.tokenId?.tokenId
        );
        const priority_payload = _.groupBy(
          filteredData?.filter((v) => v?.eventTokenId?.tokenId?.isPriorityPass),
          (id) => id?.eventTokenId?.tokenId?.tokenId
        );
        const global_payload = _.groupBy(
          filteredData?.filter(
            (v) =>
              !v?.eventTokenId?.tokenId?.isPreselect &&
              !v?.eventTokenId?.tokenId?.isPriorityPass
          ),
          (id) => id?.eventTokenId?.tokenId?.tokenId
        );

        if (individualFlag) {
          const individual_payload = {
            preselect: 0,
            priority: 0,
            global: 0,
            AllottedPreselect: 0,
            AllottedPriority: 0,
            AllottedGlobal: 0,
          };

          filteredData?.forEach((v) => {
            if (
              v?.eventTokenId?.tokenId?.isPreselect &&
              v?.AllotmentPayment.length === 0
            ) {
              individual_payload.preselect += 1;
            } else if (
              v?.eventTokenId?.tokenId?.isPriorityPass &&
              v?.AllotmentPayment.length === 0
            ) {
              individual_payload.priority += 1;
            } else if (
              !v?.eventTokenId?.tokenId?.isPreselect &&
              !v?.eventTokenId?.tokenId?.isPriorityPass &&
              v?.AllotmentPayment.length === 0
            ) {
              individual_payload.global += 1;
            } else if (
              v?.eventTokenId?.tokenId?.isPreselect &&
              v?.AllotmentPayment.length
            ) {
              individual_payload.AllottedPreselect += 1;
            } else if (
              v?.eventTokenId?.tokenId?.isPriorityPass &&
              v?.AllotmentPayment.length
            ) {
              individual_payload.AllottedPriority += 1;
            } else if (
              !v?.eventTokenId?.tokenId?.isPreselect &&
              !v?.eventTokenId?.tokenId?.isPriorityPass &&
              v?.AllotmentPayment.length
            ) {
              individual_payload.AllottedGlobal += 1;
            }
          });
          setTokenCount(individual_payload);
        }

        const preselect_data = Object.values(preselect_payload)?.map((v) => {
          let active = 0;
          let partial = 0;
          let pending = 0;

          v?.map((i) => {
            if (i.status === 'active') {
              active += 1;
            } else if (i.status === 'partial') {
              partial += 1;
            } else if (i?.status === 'pending') {
              pending += 1;
            }
          });

          return {
            v,
            active: active,
            partial: partial,
            pending: pending,
          };
        });

        const priority_data = Object.values(priority_payload)?.map((v) => {
          let active = 0;
          let partial = 0;
          let pending = 0;

          v?.map((i) => {
            if (i.status === 'active') {
              active += 1;
            } else if (i.status === 'partial') {
              partial += 1;
            } else if (i?.status === 'pending') {
              pending += 1;
            }
          });

          return {
            v,
            active: active,
            partial: partial,
            pending: pending,
          };
        });

        const global_data = Object.values(global_payload)?.map((v) => {
          let active = 0;
          let partial = 0;
          let pending = 0;

          v?.map((i) => {
            if (i.status === 'active') {
              active += 1;
            } else if (i.status === 'partial') {
              partial += 1;
            } else if (i?.status === 'pending') {
              pending += 1;
            }
          });

          return {
            v,
            active: active,
            partial: partial,
            pending: pending,
          };
        });

        setPreselectToken(preselect_data);
        setPriorityPassToken(priority_data);
        setGlobalToken(global_data);
        dismissLoader();
      })
      .catch((err) => {
        dismissLoader();
        errorTost(err.message);
      });
  };

  const getPaymentStatusData = async (
    selectProject = [],
    selectedDates = null
  ) => {
    presentLoader();
    await getPaymentStatusByIds(
      loggedInUser?.isTeamLead && loggedInUser?.isTeamLead === true
        ? userIds
        : [loggedInUser?.userId],
      selectProject?.length !== 0 ? selectProject : [],
      selectedDates
    )
      .then((resp) => {
        getAllAllotmentData(resp);
        const payload = _.groupBy(
          resp?.data?.filter(
            (v) =>
              v?.leadId !== null &&
              v?.unitId?.projectId !== null &&
              v?.unitId !== null
          ),
          (id) => id?.unitId?.projectId?.projectId
        );
        const data = Object.values(payload).map((val) => {
          return {
            val,
            total: val?.length,
            projectName: val[0]?.unitId?.projectId?.projectShortCode,
            id: _.uniqueId('prefix-'),
          };
        });

        const topProjects = data.sort((a, b) => b.total - a.total).slice(0, 5);
        setProjectList(
          topProjects?.map((val) => {
            return val?.projectName;
          })
        );
        const finalPayload = topProjects?.map((val) => {
          let sdrPendingCount = 0;
          let sdrCompleteCount = 0;
          let ocrPendingCount = 0;
          let ocrCompleteCount = 0;
          let pendingCount = 0;
          let completeCount = 0;
          let partialCount = 0;
          val?.val?.map((v) => {
            if (v?.paidAmt?.sdr >= v?.unitCost?.sdr) {
              sdrCompleteCount += 1;
            }
            if (v?.paidAmt?.sdr < v?.unitCost?.sdr) {
              sdrPendingCount += 1;
            }
            if (v?.paidAmt?.ocr >= (v?.unitCost?.bsp * 10) / 100) {
              ocrCompleteCount += 1;
            }

            if (v?.paidAmt?.ocr < (v?.unitCost?.bsp * 10) / 100) {
              ocrPendingCount += 1;
            }

            if (v?.paidAmount === 0) {
              pendingCount += 1;
            }

            if (v?.paidAmount >= v.bookingAmt.total) {
              completeCount += 1;
            }

            if (v?.paidAmount > 0 && v?.paidAmount < v.bookingAmt.total) {
              partialCount += 1;
            }
          });
          return {
            ...val,
            sdrComplete: sdrCompleteCount,
            sdrPending: sdrPendingCount,
            ocrComplete: ocrCompleteCount,
            ocrPending: ocrPendingCount,
            pending: pendingCount,
            partial: partialCount,
            complete: completeCount,
          };
        });

        setPaymentStatusData(finalPayload);

        return;
      })
      .catch((err) => {
        errorTost(err.message);
        return;
      });
  };
  const getIndividualSiteVisits = async (userId) => {
    presentLoader();
    individualSiteVisits(userId).then((resp) => {
      const data = _.groupBy(resp, (id) => id?.projectId?.projectId)
        const topSiteVisitProjects = Object.values(data)?.sort((a, b) => b.length - a.length).slice(0, 5)
      setIndividualSiteVisit(topSiteVisitProjects)
      dismissLoader();
    }).catch((err) => {
      dismissLoader();
      errorTost(err.message)
    })
  }
  const getIndividualAllotments = async (
    selectProject = [],
    selectedDates = null
  ) => {
    presentLoader();
    getAllotmentByUser(
      loggedInUser?.userId,
      selectProject?.length !== 0 ? selectProject : [],
      selectedDates
    )
      .then((userResp) => {
        const pay_load = userResp.data
          .filter(
            (f) =>
              f.unitId?.projectId !== null &&
              f?.leadId !== null &&
              f?.leadId?.personId !== null &&
              f?.unitId !== null
          )
          .map((m) => ({
            ...m,
            id: m?.allotmentPaymentId,
          }));
        setIndividualAllotment(pay_load.slice(0, 5));
        dismissLoader();
      })
      .catch((err) => {
        errorTost(err.message);
      });
  };

  const getIndividualLeadConversion = async (
    selectedProject = [],
    selectedDates = null
  ) => {
    presentLoader();
    getFirstSelectedEventData();
    console.log("selectedProject.length", selectedProject.length, allSelected.length);
    
    getLeadConversionByIds(
      loggedInUser?.isTeamLead && loggedInUser?.isTeamLead === true
        ? userIds
        : [loggedInUser?.userId],
      selectedDates,
      selectedProject
    )
      .then((LeadResp) => {
        const payload = {
          claimed: 0,
          siteVisit: 0,
          token: 0,
          allotment: 0,
          cancellation: 0,
        };
        LeadResp?.data?.filter((ele)=> {
          if (selectedProject.length === projectDataList.length || allSelected.length===0) {
            return ele;
          }
          if (ele?.allotmentPaymentId) {
            return selectedProject.includes(ele?.allotmentPaymentId?.unitId?.projectId);
          }
        })?.map((val, index) => {
          if (
            val?.status === 'Claimed' ||
            val?.status === 'Site Visit Scheduled' ||
            val?.status === 'Site Visit Pending'
          ) {
            payload.claimed++;
          } else if (val?.status === 'Site Visit Done') {
            payload.siteVisit++;
          } else if (
            val?.status === 'Token Payment Pending' ||
            val?.status === 'Token Partial Payment Done' ||
            val?.status === 'Token Payment Complete' ||
            val?.status === 'Checkpoint One Cleared' ||
            val?.status === 'Checkpoint Two Cleared' ||
            val?.status === 'Token Refund Requested' ||
            val?.status === 'Token Refunded' ||
            val?.status === 'Token Refund Request Rejected' ||
            val?.status === 'Token Payment Not Done'
          ) {
            payload.token++;
          } else if (
            val?.status === 'Allotment Done' ||
            val?.status === 'Unit On Hold' ||
            val?.status === 'Allotment Partial Payment Done' ||
            val?.status === 'Allotment Payment Pending' ||
            val?.status === 'Allotment Payment Complete' ||
            val?.status === 'PreSelect Confirmation Pending' ||
            val?.status === 'PreSelect Price Confirmation Pending' ||
            val?.status === 'PreSelect Unit On Hold' ||
            val?.status === 'PreSelect Payment Pending' ||
            val?.status === 'Preselect not confirmed' ||
            val?.status === 'PreSelect Partial Payment Done' ||
            val?.status === 'Preselect payment not done' ||
            val?.status === 'Change Unit Requested' ||
            val?.status === 'Change Unit Confirmation Pending' ||
            val?.status === 'Change Unit Confirmation Rejected' ||
            val?.status === 'Change Unit Confirmed' ||
            val?.status === 'Change Unit Rejected' ||
            val?.status === 'Cancellation Confirmation Pending' ||
            val?.status === 'Cancel Unit Rejected' ||
            val?.status === 'Cancel Unit Confirmation Rejected' ||
            val?.status === 'Cancellation Pending' ||
            val?.status === 'Cancellation Not Done' ||
            val?.status === 'Payment Pending' ||
            val?.status === 'Unit Change Requested' ||
            val?.status === 'Allotment Refunded' ||
            val?.status === 'Change Unit Done'
          ) {
            payload.allotment++;
          } else if(
            val?.status !== 'Cancellation Pending' ||
            val?.status !== 'Allotment Partial Payment Done' ||
            val?.status !== 'Allotment Payment Pending' ||
            val?.status !== 'Unit On Hold' ||
            val?.status !== 'Token Payment Pending' ||
            val?.status !== 'Token Partial Payment Done' ||
            val?.status !== 'Token Payment Complete' ||
            val?.status !== 'Agreement Done' || 
            val?.status === 'Cancellation Done' 
          ){
            payload.cancellation++;
          }
        });

        setLeadConversionData(payload);
      })
      .catch((err) => {
        errorTost(err.message);
      });
  };

  const getAllAllotmentData = (val) => {
    const payload = _.groupBy(
      val?.data?.filter(
        (v) =>
          v?.leadId?.leadId !== null &&
          v?.unitId?.projectId !== null &&
          v?.unitId !== null &&
          v?.leadId?.userId?.userId !== null &&
          v?.leadId !== null
      ),
      (id) => id?.unitId?.projectId?.projectId
    );

    const data = Object.values(payload).map((val) => {
      let cost = 0;
      let area = 0;
      let sold = 0;
      val?.map((i) => {
        if (
          i.unitId?.inventoryStatusId?.status === 'Preselected' ||
          i.unitId?.inventoryStatusId?.status === 'Payment Pending' ||
          i.unitId?.inventoryStatusId?.status === 'Kyc Pending' ||
          i.unitId?.inventoryStatusId.status === 'Kyc Done' ||
          i.unitId.inventoryStatusId.status === 'Sold'
        ) {
          cost += i?.unitCost?.total ? i?.unitCost?.total : 0;
          area += i?.unitId?.chargeableArea ?? 0;
          sold += 1;
        }
      });
      return {
        val,
        cost,
        area: area.toFixed(2),
        total: val?.length,
        sold,
        totalUnit: sold,
        id: _.uniqueId('prefix-'),
      };
    });

    setAllAllotmentData(data.sort((a, b) => b.sold - a.sold).slice(0, 5));
  };

  const getInventoryCount = async (selectProject = [], selectedDate) => {
    presentLoader();
    await FetchInventoryFromServer(
      0,
      0,
      loggedInUser?.isTeamLead && loggedInUser?.isTeamLead === true
        ? userIds
        : [loggedInUser?.userId],
      selectProject?.length !== 0 ? selectProject : [],
      null,
      selectedDate
    )
      .then((val) => {
        const payload = _.groupBy(val?.data, (id) => id?.projectId);

        let purchasedRev = 0;
        const data = Object.values(payload).map((val) => {
          let sold = 0;
          let unsold = 0;
          val?.map((i) => {
            if (
              i?.inventoryStatusId?.status === 'Kyc Pending' ||
              i?.inventoryStatusId?.status === 'Kyc Done' ||
              i?.inventoryStatusId?.status === 'Sold' ||
              i?.inventoryStatusId?.status === 'Preselected' ||
              i?.inventoryStatusId?.status === 'Payment Pending'
            ) {
              sold += 1;
              purchasedRev = purchasedRev + (i?.totalCost ? i?.totalCost : 0);
            }

            if (
              i?.inventoryStatusId?.status === 'Available' ||
              i?.inventoryStatusId?.status === 'Locked' ||
              i?.inventoryStatusId?.status === 'Reserved' ||
              i?.inventoryStatusId?.status === 'On Hold'
            ) {
              unsold += 1;
            }
          });
          return {
            val,
            sold,
            unsold,
            totalUnit: sold + unsold,
            id: _.uniqueId('prefix-'),
          };
        });
        setPurchasedRevenue(purchasedRev);
        console.log("abcd", data.sort((a, b) => b.totalUnit - a.totalUnit).slice(0, 5));
        
        if (!individualFlag) {
          setInventory(
            data.sort((a, b) => b.totalUnit - a.totalUnit).slice(0, 5)
          );
        }

        dismissLoader();
        return;
      })
      .catch((err) => {
        dismissLoader();
        errorTost(err.message);
        return;
      });
  };

  const getCancelledRevenueCount = async (
    selectProject = [],
    selectedDates = null
  ) => {
    presentLoader();
    await getCancelledRevenue(
      loggedInUser?.isTeamLead && loggedInUser?.isTeamLead === true
        ? userIds
        : [loggedInUser?.userId],
      selectProject?.length > 0 ? selectProject : [],
      selectedDates
    )
      .then((val) => {
        let c = 0;
        const data = val?.data?.filter(
          (v) =>
            v?.leadId !== null &&
            v?.unitId?.projectId !== null &&
            v?.unitId?.unitId !== null &&
            v?.unitId !== null
        );
        const payloadForUnitCancelled = [];
        const groupByCancelled = _.groupBy(data, (i) => i?.unitId?.unitId);
        Object.values(groupByCancelled).forEach((v) => {
          const dataOfFilter = _.orderBy(v, 'last_updated_at', ['desc']);
          payloadForUnitCancelled.push(dataOfFilter[0]);
        });
        payloadForUnitCancelled?.forEach((v) => {
          c = c + (v.unitCost?.total ? v?.unitCost?.total : 0);
        });
        setCancelledRevenue(c);
        return;
      })
      .catch((err) => {
        errorTost(err.message);
        return;
      });
  };

  const handleProjectChange = async (e) => {
    const _value = e?.target?.value;
    if (_value !== '') {
      if (_value[_value.length - 1] === 'all') {
        setSelectedProject(
          selectedProject.length === allSelected.length
            ? []
            : allSelected
        );
        // return;
      }
      const value = _value[_value.length - 1] === 'all' ? selectedProject.length === allSelected.length
      ? []
      : allSelected : _value
      setPurchasedRevenue(0);
      setCancelledRevenue(0);
      setSelectedProject(value);
      navigate(
        `/home/Dashboard?projectName=${
          value?.length > 0
            ? value
                .map((v) => {
                  return v?.name;
                })
                .toString()
            : 'All'
        }?startDate=${
          selectDates[0]?.value !== '' ? selectDates[0]?.value : 0
        }?endDate=${selectDates[1]?.value !== '' ? selectDates[1]?.value : 0}`
      );
      presentLoader();
      await getCancelledRevenueCount(
        value?.length > 0
          ? value.map((v) => {
              return v?.id;
            })
          : projectDataList.map((v) => {
              return v?.id;
            }),
        selectDates
      )
        .then(async () => {
          await getPaymentStatusData(
            value?.length > 0
              ? value.map((v) => {
                  return v?.id;
                })
              : projectDataList.map((v) => {
                  return v?.id;
                }),
            selectDates
          )
            .then(async () => {
              await getInventoryCount(
                value?.length > 0
                  ? value.map((v) => {
                      return v?.id;
                    })
                  : projectDataList.map((v) => {
                      return v?.id;
                    }),
                selectDates
              )
                .then(() => {
                  dismissLoader();
                })
                .catch((err) => {
                  dismissLoader();
                  errorTost(err.message);
                });
              if (individualFlag) {
                await getIndividualLeadConversion(
                  value?.length > 0
                    ? value.map((v) => {
                        return v?.id;
                      })
                    : projectDataList.map((v) => {
                        return v?.id;
                      }),
                  selectDates
                )
                  .then(async () => {
                    await getIndividualAllotments(
                      value?.length > 0
                        ? value.map((v) => {
                            return v?.id;
                          })
                        : projectDataList.map((v) => {
                            return v?.id;
                          }),
                      selectDates
                    )
                      .then(() => {
                        dismissLoader();
                      })
                      .catch((e) => {
                        dismissLoader();
                        errorTost(e.message);
                      });
                      await getIndividualSiteVisits(loggedInUser?.userId)
                  })
                  .catch((e) => {
                    dismissLoader();
                    errorTost(e.message);
                  });
              }
            })
            .catch((err) => {
              dismissLoader();
              errorTost(err.message);
            });
        })
        .catch((err) => {
          dismissLoader();
          errorTost(err.message);
        });
    }
  };

  const handleStartDateChange = async (value) => {
    setSelectDates((pre) => {
      pre[0].value = value === '' ? '' : value?.getTime();
      return { ...pre };
    });
    setHelperText((pre) => {
      pre.endDate = '';
      return { ...pre };
    });
    navigate(
      `/home/Dashboard?projectName=${
        selectedProject?.length > 0
          ? selectedProject
              ?.map((val) => {
                return val.name;
              })
              .toString()
          : 'All'
      }?startDate=${value === '' ? 0 : value?.getTime()}?endDate=${
        selectDates[1]?.value !== '' ? selectDates[1]?.value : 0
      }`
    );
    if (selectDates[0]?.value !== '' && selectDates[1]?.value !== '') {
      setPurchasedRevenue(0);
      setCancelledRevenue(0);
      presentLoader();
      await getCancelledRevenueCount(
        selectedProject?.map((i) => {
          return i?.id;
        }),
        [
          {
            label: 'StartDate',
            value: value === '' ? 0 : value?.getTime(),
          },
          {
            label: 'EndDate',
            value: selectDates[1]?.value,
          },
        ]
      )
        .then(async () => {
          await getPaymentStatusData(
            selectedProject?.map((i) => {
              return i?.id;
            }),
            [
              {
                label: 'StartDate',
                value: value === '' ? 0 : value?.getTime(),
              },
              {
                label: 'EndDate',
                value: selectDates[1]?.value,
              },
            ]
          )
            .then(async () => {
              await getInventoryCount(
                selectedProject?.map((i) => {
                  return i?.id;
                }),
                [
                  {
                    label: 'StartDate',
                    value: value === '' ? 0 : value?.getTime(),
                  },
                  {
                    label: 'EndDate',
                    value: selectDates[1]?.value,
                  },
                ]
              )
                .then(() => {
                  dismissLoader();
                })
                .catch((err) => {
                  dismissLoader();
                  errorTost(err.message);
                });

              if (individualFlag) {
                await getIndividualLeadConversion(
                  selectedProject?.map((i) => {
                    return i?.id;
                  }),
                  [
                    {
                      label: 'StartDate',
                      value: value === '' ? 0 : value?.getTime(),
                    },
                    {
                      label: 'EndDate',
                      value: selectDates[1]?.value,
                    },
                  ]
                )
                  .then(async () => {
                    await getIndividualAllotments(
                      selectedProject?.map((i) => {
                        return i?.id;
                      }),
                      [
                        {
                          label: 'StartDate',
                          value: value === '' ? 0 : value?.getTime(),
                        },
                        {
                          label: 'EndDate',
                          value: selectDates[1]?.value,
                        },
                      ]
                    )
                      .then(() => {
                        dismissLoader();
                      })
                      .catch((e) => {
                        dismissLoader();
                        errorTost(e.message);
                      });
                  })
                  .catch((e) => {
                    dismissLoader();
                    errorTost(e.message);
                  });
              }
            })
            .catch((err) => {
              dismissLoader();
              errorTost(err.message);
            });
        })
        .catch((err) => {
          dismissLoader();
          errorTost(err.message);
        });
    }
  };

  const handleEndDateChange = async (value) => {
    if (selectDates[0].value === '') {
      setHelperText((pre) => {
        pre.endDate = 'Please select start date first';
        return { ...pre };
      });
    } else {
      if (selectDates[0].value > value) {
        setHelperText((pre) => {
          pre.endDate = 'Select End Date Greater than start Date';
          return { ...pre };
        });
        setSelectDates((pre) => {
          pre[1].value = '';
          return { ...pre };
        });
      } else {
        setSelectDates((pre) => {
          pre[1].value = value === '' ? '' : value?.getTime();
          return { ...pre };
        });
        navigate(
          `/home/Dashboard?projectName=${
            selectedProject?.length > 0
              ? selectedProject
                  ?.map((val) => {
                    return val.name;
                  })
                  .toString()
              : 'All'
          }?startDate=${
            selectDates[0]?.value !== '' ? selectDates[0]?.value : 0
          }?endDate=${value === '' ? 0 : value?.getTime()}`
        );
        if (selectDates[0]?.value !== '' && selectDates[1]?.value !== '') {
          setPurchasedRevenue(0);
          setCancelledRevenue(0);
          presentLoader();
          await getCancelledRevenueCount(
            selectedProject?.map((i) => {
              return i?.id;
            }),
            [
              {
                label: 'StartDate',
                value: selectDates[0]?.value,
              },
              {
                label: 'EndDate',
                value: value === '' ? 0 : value?.getTime(),
              },
            ]
          )
            .then(async () => {
              await getPaymentStatusData(
                selectedProject?.map((i) => {
                  return i?.id;
                }),
                [
                  {
                    label: 'StartDate',
                    value: selectDates[0]?.value,
                  },
                  {
                    label: 'EndDate',
                    value: value === '' ? 0 : value?.getTime(),
                  },
                ]
              )
                .then(async () => {
                  await getInventoryCount(
                    selectedProject?.map((i) => {
                      return i?.id;
                    }),
                    [
                      {
                        label: 'StartDate',
                        value: selectDates[0]?.value,
                      },
                      {
                        label: 'EndDate',
                        value: value === '' ? 0 : value?.getTime(),
                      },
                    ]
                  )
                    .then(() => {
                      dismissLoader();
                    })
                    .catch((e) => {
                      dismissLoader();
                      errorTost(e.message);
                    });

                  if (individualFlag) {
                    await getIndividualLeadConversion(
                      selectedProject?.map((i) => {
                        return i?.id;
                      }),
                      [
                        {
                          label: 'StartDate',
                          value: selectDates[0]?.value,
                        },
                        {
                          label: 'EndDate',
                          value: value === '' ? 0 : value?.getTime(),
                        },
                      ]
                    )
                      .then(async () => {
                        await getIndividualAllotments(
                          selectedProject?.map((i) => {
                            return i?.id;
                          }),
                          [
                            {
                              label: 'StartDate',
                              value: selectDates[0]?.value,
                            },
                            {
                              label: 'EndDate',
                              value: value === '' ? 0 : value?.getTime(),
                            },
                          ]
                        )
                          .then(() => {
                            dismissLoader();
                          })
                          .catch((e) => {
                            dismissLoader();
                            errorTost(e.message);
                          });
                      })
                      .catch((e) => {
                        dismissLoader();
                        errorTost(e.message);
                      });
                  }
                })
                .catch((e) => {
                  dismissLoader();
                  errorTost(e.message);
                });
            })
            .catch((e) => {
              dismissLoader();
              errorTost(e.message);
            });
        }

        setHelperText((pre) => {
          pre.endDate = '';
          return { ...pre };
        });
      }
    }
  };

  const handleEventChange = (e) => {
    if (!e) {
      setSelectedEvent(null);
      
    } else {
      const payload = eventOption.filter((v) => v.label === e.label);
      setSelectedEvent(payload[0]);
      setSelectedLaunch(null)
    }
    navigate(
      `/home/Dashboard?eventName=${e?.label}?startDate=${
        selectDates[0]?.value !== '' ? selectDates[0]?.value : 0
      }?endDate=${selectDates[1]?.value !== '' ? selectDates[1]?.value : 0}`
    );
  };

  const handleLaunchChange = (e) => {
    if (!e) {
      setSelectedLaunch(null);
    } else {
      const payload = launchOption.filter((v) => v.label === e.label);
      setSelectedLaunch(payload[0]);
    }
  };

  return (
    <div className={cssClasses.dashboardWrapper}>
      <Box mb={2}>
        <Box className={cssClasses.SubContainer}>
          <Box className={cssClasses.DivContainer}>
            <Box className={cssClasses.HeaderTitle} mt={3}>
              Dashboard
            </Box>
          </Box>
          <Box className={cssClasses.SubContainer} marginLeft={'auto'}>
            <Box>
              <Box className={cssClasses.SubTitle}>Start date:</Box>
              <DateComponent
                value={selectDates[0].value}
                minDate={new Date('01/01/2023')}
                maxDate={
                  selectDates[1]?.value !== ''
                    ? new Date(selectDates[1]?.value)
                    : new Date()
                }
                onChangeDate={(value) => {
                  handleStartDateChange(value);
                }}
                helperText={helperText.startDate}
              ></DateComponent>
            </Box>
            <Box>
              <Box className={cssClasses.SubTitle}>End date:</Box>
              <DateComponent
                value={selectDates[1].value}
                isClassName
                minDate={new Date(selectDates[0]?.value)}
                maxDate={new Date()}
                onChangeDate={(value) => {
                  handleEndDateChange(value);
                }}
                helperText={helperText.endDate}
              ></DateComponent>
            </Box>
            <Box>
              <Box className={cssClasses.SubTitle}>Project:</Box>
              <MultiSelectDropDown
                list={projectDataList}
                value={selectedProject}
                handleChange={(e) => {
                  handleProjectChange(e);
                }}
                flag={true}
                setAllSelected={setAllSelected}
              />
            </Box>
          </Box>
        </Box>
      </Box>

      <div className={cssClasses.statesticWrapper}>
        {RevenueComponent(
          purchasedRevenue,
          cancelledRevenue,
          selectedProject,
          selectDates
        )}
        {!individualFlag ? (
          <>
            <Card
              style={{
                padding: '2rem 2rem 1rem 2rem',
                width: '100%',
                minHeight: '100%',
              }}
            >
              <div className={cssClasses.keyMatricsWrapper}>
                <div
                  style={{ display: 'flex', alignItems: 'center', gap: '2rem' }}
                >
                  <label
                    style={{ fontSize: '1.8rem', fontFamily: 'inter-semibold' }}
                  >
                    Payment Status
                  </label>
                  <label
                    style={{
                      color: 'rgba(112, 123, 154, 1)',
                      fontSize: '1.5rem',
                      textDecoration: 'underline',
                      cursor: 'pointer',
                    }}
                    onClick={() =>
                      mode === 'Allotment'
                        ? navigate(
                            `/home/Dashboard/PaymentStatus?projectName=${
                              selectedProject?.length > 0
                                ? selectedProject
                                    ?.map((val) => {
                                      return val.name;
                                    })
                                    .toString()
                                : 'All'
                            }?startDate=${
                              selectDates[0]?.value !== ''
                                ? selectDates[0]?.value
                                : 0
                            }?endDate=${
                              selectDates[1]?.value !== ''
                                ? selectDates[1]?.value
                                : 0
                            }`
                          )
                        : navigate(
                            `/home/Dashboard/TokenPaymentStatus?eventName=${
                              selectedEvent?.label
                            }?startDate=${
                              selectDates[0]?.value !== ''
                                ? selectDates[0]?.value
                                : 0
                            }?endDate=${
                              selectDates[1]?.value !== ''
                                ? selectDates[1]?.value
                                : 0
                            }`
                          )
                    }
                  >
                    View Details
                  </label>
                </div>
                <div
                  style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}
                >
                  <ToggleButtonGroup size='medium'>
                    <Tooltip
                      title={<p style={{ fontSize: '1.5rem' }}>Allotment</p>}
                    >
                      <ToggleButton
                        sx={{
                          padding: '0.7rem',
                          marginTop: '0.5rem',
                          fontFamily: 'inter-semibold',
                          fontSize: '1.3rem',
                          background: `${
                            mode === 'Allotment' ? 'rgba(21, 112, 239, 1)' : ''
                          }`,
                          color: `${mode === 'Allotment' ? '#fff' : '#000'}`,
                          '&:hover': {
                            background: `${
                              mode === 'Allotment'
                                ? 'rgba(21, 112, 239, 1)'
                                : ''
                            }`,
                            color: `${mode === 'Allotment' ? '#fff' : '#000'}`,
                          },
                        }}
                        onClick={() => {
                          setMode('Allotment');
                          navigate(
                            `/home/Dashboard?projectName=${
                              selectedProject?.length > 0
                                ? selectedProject
                                    ?.map((val) => {
                                      return val.name;
                                    })
                                    .toString()
                                : 'All'
                            }?startDate=${
                              selectDates[0]?.value !== ''
                                ? selectDates[0]?.value
                                : 0
                            }?endDate=${
                              selectDates[1]?.value !== ''
                                ? selectDates[1]?.value
                                : 0
                            }`
                          );
                        }}
                      >
                        Allotment
                      </ToggleButton>
                    </Tooltip>
                    <Tooltip
                      title={<p style={{ fontSize: '1.5rem' }}>Token</p>}
                    >
                      <ToggleButton
                        sx={{
                          padding: '0.7rem',
                          marginTop: '0.5rem',
                          fontFamily: 'inter-semibold',
                          fontSize: '1.3rem',
                          background: `${
                            mode === 'Token' ? 'rgba(21, 112, 239, 1)' : ''
                          }`,
                          color: `${mode === 'Token' ? '#fff' : '#000'}`,
                          '&:hover': {
                            background: `${
                              mode === 'Token' ? 'rgba(21, 112, 239, 1)' : ''
                            }`,
                            color: `${mode === 'Token' ? '#fff' : '#000'}`,
                          },
                        }}
                        onClick={() => {
                          setMode('Token');
                          getFirstSelectedEventData();
                        }}
                      >
                        Token
                      </ToggleButton>
                    </Tooltip>
                  </ToggleButtonGroup>
                  {mode !== 'Allotment' && (
                    <div style={{ width: '160px' }}>
                      <CustomAutoComplete
                        NoOptionsText={'No event found'}
                        InitialValue={(e) => {
                          handleEventChange(e);
                        }}
                        list={eventOption}
                        multiple={false}
                        disable={false}
                        value={selectedEvent}
                      />
                    </div>
                  )}
                </div>
              </div>
              {mode === 'Allotment' && (
                <div
                  className={cssClasses.keyDataContainer}
                  style={{ height: '300px' }}
                >
                  {paymentStatusData?.length === 0
                    ? ''
                    : mode === 'Allotment' && (
                        <Bar
                          style={{
                            width: '100% !important',
                            height: '100% !important',
                          }}
                          data={{
                            labels: projectList,
                            datasets: [
                              {
                                label: 'Complete',
                                type: 'bar',
                                stack: 'Payment',
                                backgroundColor: 'rgba(48, 144, 3, 1)',
                                data: paymentStatusData?.map((val) => {
                                  return val?.complete;
                                }),
                              },
                              {
                                label: 'Pending',
                                type: 'bar',
                                stack: 'Payment',
                                backgroundColor: 'rgba(214, 61, 50, 1)',
                                data: paymentStatusData?.map((val) => {
                                  return val?.pending;
                                }),
                              },
                              {
                                label: 'Partial',
                                type: 'bar',
                                stack: 'Payment',
                                backgroundColor: 'rgba(255, 173, 49, 1)',
                                data: paymentStatusData?.map((val) => {
                                  return val?.partial;
                                }),
                              },
                              {
                                label: 'Balance SDR Complete',
                                type: 'bar',
                                stack: 'SDR',
                                backgroundColor: 'rgba(22, 164, 216, 1)',
                                data: paymentStatusData?.map((val) => {
                                  return val?.sdrComplete;
                                }),
                              },
                              {
                                label: 'Balance SDR Pending',
                                type: 'bar',
                                stack: 'SDR',
                                backgroundColor: 'rgba(96, 219, 232, 1)',
                                data: paymentStatusData?.map((val) => {
                                  return val?.sdrPending;
                                }),
                              },
                              {
                                label: 'Balance OCR & GST Complete',
                                type: 'bar',
                                stack: 'OCR',
                                backgroundColor: 'rgba(155, 95, 224, 1)',
                                data: paymentStatusData?.map((val) => {
                                  return val?.ocrComplete;
                                }),
                              },
                              {
                                label: 'Balance OCR & GST Pending',
                                type: 'bar',
                                stack: 'OCR',
                                backgroundColor: 'rgba(202, 168, 241, 1)',
                                data: paymentStatusData?.map((val) => {
                                  return val?.ocrPending;
                                }),
                              },
                            ],
                          }}
                          options={{
                            plugins: {
                              legend: {
                                display: true,
                                position: 'right',
                              },
                            },
                            indexAxis: 'x',
                            responsive: true,
                            maintainAspectRatio: false,
                            scales: {
                              xAxes: [
                                {
                                  stacked: true,
                                  ticks: {
                                    beginAtZero: true,
                                    maxRotation: 0,
                                    minRotation: 0,
                                  },
                                },
                              ],
                              yAxes: [
                                {
                                  stacked: true,
                                },
                              ],
                            },
                            scales: {
                              x: {
                                grid: {
                                  display: false,
                                },
                              },
                              y: {
                                grid: {
                                  display: false,
                                },
                              },
                            },
                          }}
                        />
                      )}
                </div>
              )}
              {mode !== 'Allotment' && (
                <div
                  className={cssClasses.keyDataContainer}
                  style={{ height: '300px' }}
                >
                  {paymentStatusData?.length === 0 ? (
                    ''
                  ) : (
                    <Bar
                      style={{
                        width: '100% !important',
                        height: '100% !important',
                      }}
                      data={{
                        labels: [
                          ...preselectToken?.map((v) => {
                            return v?.v[0]?.eventTokenId?.tokenId?.name;
                          }),
                          ...priorityPassToken?.map((v) => {
                            return v?.v[0]?.eventTokenId?.tokenId?.name;
                          }),
                          ...globalToken?.map((v) => {
                            return v?.v[0]?.eventTokenId?.tokenId?.name;
                          }),
                        ],
                        datasets: [
                          {
                            label: 'Active',
                            barThickness: 20,
                            data: [
                              ...preselectToken?.map((v) => {
                                return v?.active;
                              }),
                              ...priorityPassToken?.map((v) => {
                                return v?.active;
                              }),
                              ...globalToken?.map((v) => {
                                return v?.active;
                              }),
                            ],
                            backgroundColor: 'rgba(7, 126, 140, 1)',
                          },
                          {
                            label: 'Partial',
                            barThickness: 20,
                            data: [
                              ...preselectToken?.map((v) => {
                                return v?.partial;
                              }),
                              ...priorityPassToken?.map((v) => {
                                return v?.partial;
                              }),
                              ...globalToken?.map((v) => {
                                return v?.partial;
                              }),
                            ],
                            backgroundColor: 'rgba(247, 203, 115, 1)',
                          },
                          {
                            label: 'Pending',
                            barThickness: 20,
                            data: [
                              ...preselectToken?.map((v) => {
                                return v?.pending;
                              }),
                              ...priorityPassToken?.map((v) => {
                                return v?.pending;
                              }),
                              ...globalToken?.map((v) => {
                                return v?.pending;
                              }),
                            ],
                            backgroundColor: 'rgba(242, 147, 57, 1)',
                          },
                        ],
                      }}
                      options={{
                        plugins: {
                          legend: {
                            display: true,
                            position: 'right',
                          },
                        },
                        indexAxis: 'y',
                        responsive: true,
                        maintainAspectRatio: false,
                        scales: {
                          x: {
                            stacked: true,
                            grid: {
                              display: false,
                            },
                          },
                          y: {
                            stacked: true,
                            grid: {
                              display: false,
                            },
                          },
                        },
                      }}
                    />
                  )}
                </div>
              )}
            </Card>
          </>
        ) : (
          <>
            {IndividualDashboard(
              paymentStatusData,
              leadConversionData,
              projectList,
              selectedProject,
              selectDates
            )}
          </>
        )}
      </div>

      {tableContainer(
        allAllotmentData,
        tagGridColumns,
        tagGridColumns2,
        inventory,
        siteVisit,
        individualSiteVisit,
        tagGridColumns1,
        individualFlag,
        individualAllotment,
        IndividualGridColumns,
        eventOption,
        handleEventChange,
        selectedEvent,
        tokenCount,
        navigate,
        selectedProject,
        selectDates,
        handleLaunchChange,
        launchOption,
        selectedLaunch,
        noTVBFound
      )}
    </div>
  );
};

function revenueCard(amount, isPurchasedRevenue) {
  return (
    <Card className={cssClasses.revenueCard}>
      <div>
        <img src={RuppesIcon} alt='ruppes' />
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '1rem',
        }}
      >
        <label
          style={{
            fontSize: '1.4rem',
            color: 'rgba(112, 123, 154, 1)',
          }}
        >
          {`${isPurchasedRevenue ? 'Punched' : 'Current'}`} Revenue
        </label>
        <label className={cssClasses.amountText}>
          <span className={cssClasses.ruppesSymbol}>₹</span>
          {`${numDifferentiation(amount)}.`}
        </label>
      </div>
    </Card>
  );
}

function IndividualDashboard(
  paymentStatusData,
  leadConversionData,
  projectList,
  selectedProject,
  selectDates
) {
  const navigate = useNavigate();
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        gap: '2rem',
        width: '100%',
      }}
    >
      <Card
        style={{
          padding: '1rem 1rem 1rem 1rem',
          width: '50%',
          minHeight: '100%',
        }}
      >
        <div style={{ margin: '2rem' }}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              gap: '1rem',
              margin: '2rem 0rem',
              justifyContent: 'space-between',
            }}
          >
            <label
              style={{
                fontSize: '1.8rem',
                fontFamily: 'inter-semibold',
                lineHeight: '2rem',
              }}
            >
              My Performance
            </label>
            <label
              style={{
                fontSize: '1.2rem',
                color: '#707B9A',
                marginTop: '0.2rem',
              }}
            >
              (leads to conversion)
            </label>
          </div>
          <Divider />

          <div
            className={cssClasses.keyDataContainer}
            style={{ height: '240px' }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <div
                style={{
                  color: '#3A3F56',
                  fontSize: '2rem',
                  lineHeight: '2.7rem',
                }}
              >
                {leadConversionData?.claimed +
                  leadConversionData?.siteVisit +
                  leadConversionData?.token +
                  leadConversionData?.allotment +
                  leadConversionData?.cancellation ?? 0}{' '}
              </div>
              <div style={{ color: '#707B9A', fontSize: '1.6rem' }}>
                Total Leads
              </div>
            </div>

            <Doughnut
              style={{
                width: '100% !important',
                height: '100% !important',
              }}
              data={{
                labels: [
                  'Claimed Leads',
                  'Site Visits',
                  'Tokens',
                  'Allotments',
                  'Cancellation',
                ],
                datasets: [
                  {
                    label: '# of Votes',
                    data: [
                      leadConversionData?.claimed,
                      leadConversionData?.siteVisit,
                      leadConversionData?.token,
                      leadConversionData?.allotment,
                      leadConversionData?.cancellation
                    ],
                    backgroundColor: [
                      '#00A9D7',
                      '#FB8071',
                      '#1CD0BB',
                      '#FFA400',
                      '#db3700',
                    ],
                    borderColor: ['#00A9D7', '#FB8071', '#1CD0BB', '#FFA400', '#db3700'],
                    borderWidth: 1,
                  },
                ],
              }}
              options={{
                plugins: {
                  legend: {
                    display: true,
                    position: 'right',
                    labels: {
                      usePointStyle: true,
                      pointStyle: 'rectRounded',
                      boxWidth: 24,
                    },
                  },
                },
              }}
            />
          </div>
        </div>
      </Card>
      <Card
        style={{
          width: '50%',
          minHeight: '100%',
        }}
      >
        <div style={{ margin: '1rem' }}>
          <div
            style={{
              padding: '1rem',
              display: 'flex',
              alignItems: 'center',
              gap: '2rem',
              width: '100%',
            }}
          >
            <label
              style={{
                fontSize: '1.8rem',
                fontFamily: 'inter-semibold',
              }}
            >
              Payment Status
            </label>
            <div
              style={{
                fontSize: '1.4rem',
                textDecoration: 'underline',
                color: 'rgba(112, 123, 154, 1)',
                cursor: 'pointer',
                marginLeft: 'auto',
              }}
              onClick={() =>
                navigate(
                  `/home/Dashboard/PaymentStatus?projectName=${
                    selectedProject?.length > 0
                      ? selectedProject
                          ?.map((val) => {
                            return val.name;
                          })
                          .toString()
                      : 'All'
                  }?startDate=${
                    selectDates[0]?.value !== '' ? selectDates[0]?.value : 0
                  }?endDate=${
                    selectDates[1]?.value !== '' ? selectDates[1]?.value : 0
                  }`
                )
              }
            >
              View Details
            </div>
          </div>
          <Divider />
          <div
            className={cssClasses.keyDataContainer}
            style={{ height: '240px' }}
          >
            <Bar
              style={{
                width: '100% !important',
                height: '100% !important',
              }}
              data={{
                labels: projectList,
                datasets: [
                  {
                    label: 'Complete',
                    type: 'bar',
                    backgroundColor: 'rgba(48, 144, 3, 1)',
                    data: paymentStatusData?.map((val) => {
                      return val?.complete;
                    }),
                  },
                  {
                    label: 'Pending',
                    type: 'bar',
                    backgroundColor: 'rgba(214, 61, 50, 1)',
                    data: paymentStatusData?.map((val) => {
                      return val?.pending;
                    }),
                  },
                  {
                    label: 'Partial',
                    type: 'bar',
                    backgroundColor: 'rgba(255, 173, 49, 1)',
                    data: paymentStatusData?.map((val) => {
                      return val?.partial;
                    }),
                  },
                ],
              }}
              options={{
                plugins: {
                  legend: {
                    display: false,
                    position: 'right',
                  },
                },
                indexAxis: 'x',
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                  xAxes: [
                    {
                      stacked: true,
                      ticks: {
                        beginAtZero: true,
                        maxRotation: 0,
                        minRotation: 0,
                      },
                    },
                  ],
                  yAxes: [
                    {
                      stacked: true,
                    },
                  ],
                },
                scales: {
                  x: {
                    stacked: false,
                    // beforeUpdate(axis) {
                    //   const labels = axis.chart.data.labels;
                    //   for (let i=0; i<labels.length; i++) {
                    //     const lbl = labels[i];
                    //     if (typeof lbl === 'string' && lbl.length > 10) {
                    //       labels[i] = lbl.substring(0, 5) + '...'; // cutting
                    //     }
                    //   }
                    // },
                    grid: {
                      display: false,
                    },
                  },
                  y: {
                    grid: {
                      display: false,
                    },
                  },
                },
              }}
            />
          </div>
        </div>
      </Card>
    </div>
  );
}

function RevenueComponent(
  purchasedRevenue,
  cancelledRevenue,
  selectedProject,
  selectDates
) {
  const navigate = useNavigate();
  return (
    <div className={cssClasses.leftStatesticWrapper}>
      <div className={cssClasses.leftCardWrapper}>
        {revenueCard(
          numDifferentiation(purchasedRevenue === 0 ? 0 : purchasedRevenue),
          true
        )}
        {revenueCard(
          numDifferentiation(
            purchasedRevenue === 0 ? 0 : purchasedRevenue - cancelledRevenue
          ),
          false
        )}
      </div>
      <div style={{ height: '100%' }}>
        <Card
          style={{
            padding: '2rem 3rem',
            height: '100%',
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'space-around' }}>
            <div className={cssClasses.dataContainer}>
              <label
                style={{ fontSize: '1.6rem', fontFamily: 'inter-semibold' }}
              >
                Cancellations / Refunds
              </label>
              <label
                style={{
                  fontSize: '3.3rem',
                  color: 'rgba(21, 112, 239, 1)',
                  fontFamily: 'inter-semibold',
                  justifyContent: 'center',
                  display: 'flex',
                }}
              >
                <span
                  className={cssClasses.ruppesSymbol}
                  style={{ fontSize: '3.3rem' }}
                >
                  ₹
                </span>{' '}
                {numDifferentiation(
                  purchasedRevenue === 0
                    ? 0
                    : purchasedRevenue - (purchasedRevenue - cancelledRevenue)
                )}
              </label>
            </div>
          </div>
          <div
            style={{
              fontSize: '1.4rem',
              textDecoration: 'underline',
              color: 'rgba(112, 123, 154, 1)',
              cursor: 'pointer',
            }}
            onClick={() =>
              navigate(
                `/home/Dashboard/CancellationsAndRefunds?projectName=${
                  selectedProject?.length > 0
                    ? selectedProject
                        ?.map((val) => {
                          return val.name;
                        })
                        .toString()
                    : 'All'
                }?startDate=${
                  selectDates[0]?.value !== '' ? selectDates[0]?.value : 0
                }?endDate=${
                  selectDates[1]?.value !== '' ? selectDates[1]?.value : 0
                }`
              )
            }
          >
            View Details
          </div>
        </Card>
      </div>
    </div>
  );
}

function tableComponent(data, column) {
  return (
    <DataGrid
    getRowId={() => Math.random()}
      rows={data}
      columns={column}
      pageSize={10}
      rowsPerPageOptions={[10]}
      hideFooter
      sx={[dataGridStyles]}
    />
  );
}

function tableContainer(
  allAllotmentData,
  tagGridColumns,
  tagGridColumns2,
  inventory,
  siteVisit,
  individualSiteVisit,
  tagGridColumns1,
  individualFlagData,
  individualAllotments,
  IndividualGridColumn,
  eventOption,
  handleEventChange,
  selectedEvent,
  tokenData,
  navigate,
  selectedProject,
  selectDates,
  handleLaunchChange,
  launchOption,
  selectedLaunch,
  noTVBFound
) {

  const tooltip = {
    intersect: false,
    displayColors: false,
    callbacks: {
      label: function (context) {
        return `Token: ${
          context.label === 'GT'
            ? tokenData?.global
            : context.label === 'Priority'
            ? tokenData?.priority
            :  context.label === 'Preselect' ? tokenData?.preselect : 0
        } , Booking: ${
          context.label === 'GT'
            ? tokenData?.AllottedGlobal
            : context.label === 'Priority'
            ? tokenData?.AllottedPriority
            : context.label === 'Preselect' ? tokenData?.AllottedPreselect : 0
        } ,Total : ${
          context.label === 'GT'
            ? tokenData?.global + tokenData?.AllottedGlobal
            : context.label === 'Priority'
            ? tokenData?.priority + tokenData?.AllottedPriority
            : context.label === 'Preselect' ? tokenData?.AllottedPreselect + tokenData?.preselect : 0
        }`;
      },
    },
  };

  return (
    <div className={cssClasses.tableWrapper}>
      <Card
        style={{
          width: '48%',
          height: '35rem',
          padding: '2.4rem',
          // flex: '50%',
          height: '530px',
        }}
      >
        <div
          style={{
            marginBottom: '2rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
            <label style={{ fontSize: '1.6rem', fontFamily: 'inter-semibold' }}>
              Allotments
            </label>
          </div>
          {individualFlagData && (
            <>
              <div
                style={{
                  fontSize: '1.4rem',
                  textDecoration: 'underline',
                  color: 'rgba(112, 123, 154, 1)',
                  cursor: 'pointer',
                }}
                onClick={() =>
                  navigate(
                    `/home/Dashboard/Allotment?projectName=${
                      selectedProject?.length > 0
                        ? selectedProject?.map((val) => val.name).toString()
                        : 'All'
                    }?startDate=${
                      selectDates[0]?.value !== '' ? selectDates[0]?.value : 0
                    }?endDate=${
                      selectDates[1]?.value !== '' ? selectDates[1]?.value : 0
                    }?leadName=All`
                  )
                }
              >
                View Details
              </div>
            </>
          )}
        </div>
        <div style={{ height: '95%', paddingBottom: '1.5rem' }}>
          {!individualFlagData ? (
            <>{tableComponent(allAllotmentData, tagGridColumns)}</>
          ) : (
            <>{tableComponent(individualAllotments, IndividualGridColumn)}</>
          )}
        </div>
      </Card>
          <Card
            style={{
              width: '48%',
              height: '35rem',
              padding: '2.4rem',
              // flex: '50%',
              height: '530px',
            }}
          >
            <div
              style={{
                marginBottom: '2rem',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <div
                style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}
              >
                <label
                  style={{ fontSize: '1.6rem', fontFamily: 'inter-semibold' }}
                >
                  Site Visit
                </label>
              </div>
            </div>
            <div style={{ height: '95%', paddingBottom: '1.5rem' }}>
            {!individualFlagData ? (
            <>{tableComponent(siteVisit, tagGridColumns2)}</>
          ) : (
            <>{tableComponent(individualSiteVisit, tagGridColumns2)}</>
          )}
              {/* {tableComponent(siteVisit, tagGridColumns2)} */}
            </div>
          </Card>
      {!individualFlagData ? (
        <>
          <Card
            style={{
              width: '100%',
              height: '35rem',
              padding: '2.4rem',
              // flex: '50%',
              height: '530px',
            }}
          >
            <div
              style={{
                marginBottom: '2rem',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <div
                style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}
              >
                <label
                  style={{ fontSize: '1.6rem', fontFamily: 'inter-semibold' }}
                >
                  Inventory
                </label>
              </div>
            </div>
            <div style={{ height: '95%', paddingBottom: '1.5rem' }}>
              {tableComponent(inventory, tagGridColumns1)}
            </div>
          </Card>
        </>
      ) : (
        <>
          {noTVBFound === false ? (
            <>
              <Card sx={{width: '100%'}}>
                <div style={{ margin: '2rem' }}>
                  <div
                    style={{
                      margin: '2rem',
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                      gap: '0.5rem',
                    }}
                  >
                    <label
                      style={{
                        fontSize: '1.8rem',
                        fontFamily: 'inter-semibold',
                        marginTop: '2rem',
                      }}
                    >
                      Tokens V Booking
                    </label>
                    <div style={{display:'flex', gap:'2rem'}}>

                    <div style={{ width: '300px' }}>
                      <CustomAutoComplete
                        NoOptionsText={'No event found'}
                        InitialValue={(e) => {
                          handleEventChange(e);
                        }}
                        list={eventOption}
                        getOptionLabel={(option) => option.label || ''}
                        multiple={false}
                        disable={false}
                        value={selectedEvent}
                      />
                    </div>
                    <div style={{ width: '300px' }}>
                      <CustomAutoComplete
                        NoOptionsText={'No launches found'}
                        InitialValue={(e) => {
                          handleLaunchChange(e);
                        }}
                        list={launchOption}
                        getOptionLabel={(option) => option.label || ''}
                        multiple={false}
                        disable={false}
                        value={selectedLaunch}
                      />
                    </div>
                    </div>

                  </div>
                  <Divider />
                  <div
                    className={cssClasses.keyDataContainer}
                    style={{ height: '400px' }}
                  >
                    <Bar
                      style={{
                        width: '100% !important',
                        height: '100% !important',
                      }}
                      data={{
                        labels: ['GT', 'Priority', 'Preselect'],
                        datasets: [
                          {
                            label: 'Booking',
                            stack: 'Payment',
                            data: [
                              tokenData?.AllottedGlobal,
                              tokenData?.AllottedPriority,
                              tokenData?.AllottedPreselect,
                            ],
                            barThickness: 20,
                            backgroundColor: '#CD5547',
                          },

                          {
                            label: 'Token',
                            stack: 'Payment',
                            data: [
                              tokenData?.global,
                              tokenData?.priority,
                              tokenData?.preselect,
                            ],
                            backgroundColor: '#FB8071',
                            barThickness: 20,
                          },
                        ],
                      }}
                      options={{
                        plugins: {
                          legend: {
                            display: true,
                            position: 'bottom',
                            labels: {
                              usePointStyle: 'true',
                              pointStyle: 'circle',
                            },
                          },
                          tooltip,
                        },

                        indexAxis: 'x',
                        responsive: true,
                        maintainAspectRatio: false,
                        scales: {
                          x: {
                            grid: {
                              display: false,
                            },
                            ticks: {
                              beginAtZero: true,
                              maxRotation: 0,
                              minRotation: 0,
                            },
                          },
                        },
                      }}
                    />
                  </div>
                </div>
              </Card>
            </>
          ) : (
            <></>
            // <Card>
            //   <div className={cssClasses.keyDataContainer}
            //         style={{ height: '400px' , margin:"3rem"  , display:"flex" , flexDirection:"row" , alignItems:"center"}}>
            //     <p
            //       style={{
            //         position: 'relative',
            //         top: '100%',
            //         transform: 'translateY(-50%)',
            //         textAlign: 'center',
            //         fontSize: '3rem',
            //       }}
            //     >
            //       <div
            //         style={{
            //           display: 'flex',
            //           flexDirection: 'column',
            //           alignItems: 'center',
            //         }}
            //       >
            //         <img src={EmptyState} alt='No Data' />
            //         <span>No Data Available</span>
            //       </div>
            //     </p>
            //   </div>
            // </Card>
          )}
        </>
      )}
    </div>
  );
}

function numDifferentiation(val) {
  if (val >= 10000000) val = (val / 10000000).toFixed(2) + ' Cr';
  else if (val >= 100000) val = (val / 100000).toFixed(2) + ' Lac';
  else if (val >= 1000) val = (val / 1000).toFixed(2) + ' K';
  return val;
}

export default SalesDashboard;
